import { krdetailConstants } from '../../../../../constants/krdetails.constants';

/** MIT calculation mode (quarter_target_type UI selection / mitType prop). */
export const MIT_TYPE = Object.freeze({
  CUSTOM: 'custom',
  ADD_UP: 'addUp',
  TRACK_PROGRESSION: 'trackProgression',
  AVG_RESULTS: 'avgResults',
  SUPPORTING_QUARTER_KR: 'supportingQuarterKr',
} as const);

export type MitType = (typeof MIT_TYPE)[keyof typeof MIT_TYPE];

/** Auto-interval helper types for custom MIT date segments. */
export const MIT_INTERVAL_TYPE = Object.freeze({
  CUSTOM: 'custom',
  QUARTER: 'quarter',
  MONTH: 'month',
  WEEK: 'week',
} as const);

export type MitIntervalType = (typeof MIT_INTERVAL_TYPE)[keyof typeof MIT_INTERVAL_TYPE];

/** Persisted quarter_target_type values (server / DB). Keys align with MIT_TYPE values. */
export const QUARTER_TARGET_TYPE = Object.freeze({
  [MIT_TYPE.CUSTOM]: '1',
  [MIT_TYPE.ADD_UP]: '2',
  [MIT_TYPE.TRACK_PROGRESSION]: '3',
  [MIT_TYPE.AVG_RESULTS]: '4',
  [MIT_TYPE.SUPPORTING_QUARTER_KR]: '5',
} as const satisfies Record<MitType, string>);

export type QuarterTargetTypeValue = (typeof QUARTER_TARGET_TYPE)[MitType];

/** Pre-MR-8337 Add-up MITs could pair parent Decrease-to with child Increase-to. */
export function isLegacyAddUpDecrease(
  mitType: string | undefined,
  parentCounting: number | string | null | undefined,
): boolean {
  return mitType === MIT_TYPE.ADD_UP && Number(parentCounting) === krdetailConstants.METRIC_COUNTING_DOWN;
}

/** Child direction for MIT rows; preserves legacy Add-up + parent Decrease-to display/save. */
export function getMitChildCounting(
  mitType: string | undefined,
  parentCounting: number | string | null | undefined,
  childCounting?: number | string | null,
): number {
  if (isLegacyAddUpDecrease(mitType, parentCounting)) {
    return krdetailConstants.METRIC_COUNTING_UP;
  }
  if (parentCounting != null) {
    return Number(parentCounting);
  }
  if (childCounting != null) {
    return Number(childCounting);
  }
  return krdetailConstants.METRIC_COUNTING_UP;
}
